import React, { useEffect } from 'react';
import { socialMediaJavaScriptSrc } from './enums';

const SocialPostTwitter = ({ model }) => {
    useEffect(() => {
        const script = document.createElement('script');
        script.src = socialMediaJavaScriptSrc.TWITTER;
        document.getElementsByClassName('social-post__body')[0].appendChild(script);
    }, []);

    return (
        <div className='social-post__body' dangerouslySetInnerHTML={{ __html: model.body }}>
        </div>
    );
};

export default SocialPostTwitter;
